import React from 'react';
import BudgetComparisonCard from './components/BudgetComparisonIndex.jsx';

const DepositTransfer = ({program}) => {
  return (
      <BudgetComparisonCard program={program} />
  )
}

export default DepositTransfer;
